// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_exportTranscriptWrapper__urC76 .styles_exportButton__7w6TD {
  background-color: #fff;
  color: #6ba7a8;
  border: 2px solid #6ba7a8;
  margin: 0;
  padding: 8px 16px;
  border-radius: 12px;
  font-weight: 600;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 14px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/SingleTranscript/ExportTranscript/styles.module.scss"],"names":[],"mappings":"AACE;EACE,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AAAJ","sourcesContent":[".exportTranscriptWrapper {\n  .exportButton {\n    background-color: #fff;\n    color: #6ba7a8;\n    border: 2px solid #6ba7a8;\n    margin: 0;\n    padding: 8px 16px;\n    border-radius: 12px;\n    font-weight: 600;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    font-size: 14px;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"exportTranscriptWrapper": `styles_exportTranscriptWrapper__urC76`,
	"exportButton": `styles_exportButton__7w6TD`
};
export default ___CSS_LOADER_EXPORT___;
